import React from "react";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import LoadingOverlay from "react-loading-overlay";

import * as Constants from "../../../constants/Constants";
import "../../../assets/css/template.css";

class MyTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: "Team Member",
          field: "teamMember",
          width: 110,
        },
        {
          headerName: "In Progress",
          field: "inProcess",
          width: 80,
        },
        {
          headerName: "On Hold",
          field: "onHold",
          width: 70,
        },
        {
          headerName: "Complete",
          field: "completed",
          width: 70,
        },
        {
          headerName: "Live",
          field: "live",
          width: 50,
        },
        {
          headerName: "Total",
          field: "total",
          width: 90,
        },
      ],
      defaultColDef: {
        lockVisible: true,
        suppressMovable: true,
        filter: false,
        sortable: false,
        resizable: true,
      },
      overlayNoRowsTemplate: "No Team Member available",
    };
  }

  render() {
    return (
      <div className="myTeam">
        <LoadingOverlay active={this.props.isMyTeamLoading} spinner>
          <Row className="myTeamTitle">{Constants.MY_TEAM}</Row>
          <div className="ag-theme-balham myTeamTable">
            <AgGridReact
              columnDefs={this.state.columnDefs}
              rowData={this.props.myTeamMembers}
              defaultColDef={this.state.defaultColDef}
              overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
            />
          </div>
        </LoadingOverlay>
      </div>
    );
  }
}

export default MyTeam;
